import TradeAPAddToPortfolioFail from './TradeAPAddToPortfolioFail';

export default TradeAPAddToPortfolioFail;
